import moment from "moment";
window.addEventListener('load', () => {
    statsScriptLoad()
});

async function doGet(url) {
    return new Promise((resolve, reject) => {
        fetch(url).then(async function (response) {
            var data = await response.json();
            if(data['success'] == true) {
                if(data.hasOwnProperty('response')) {
                    resolve(data['response']);
                } else {
                    console.error(`Response data not found for ${url}`);
                    reject(null);
                }
            } else {
                console.error(`API call unsuccessful to ${url}`);
                reject(null);
            }
        }).catch(function (error) {
            console.error(`API call failed for ${url}`);
            console.error(`Error details: ${error}`);
            reject(null);
        });
    });
}

async function checkDoctorOnlineState() {
    // Check if the doctor is online and show/hide the button to speak now

    let curURL = window.location.href;
    let whiteLabel = document.querySelector('.single-whitelabel_site');
    // don't set dataLayer if in quit smoking or on whitelabel template
    if(curURL.includes('quit-smoking') || whiteLabel){
        return;
    }

    var doctorOnline = await doGet(window.API_Path + 'appointment/practitionerOnline?serviceType=doctor');
    // let currTime = moment().hour();
    // if(currTime > 8 && currTime < 18){
    //     $('.drState').closest('a').html('Speak to a Doctor Now <span class="linkOverflow"><div class="drState"></div></span>');
    // }else{
    //     $('.drState').closest('a').html('Speak to a Doctor Now <span class="linkOverflow"><div class="drState"></div></span>');
    // }
    if (doctorOnline == false) {
        $('.drState').closest('.dropdownItemParent').hide();
        // Remove the speak to a doctor button in the appointment menu if offline
        $('.speak-to-a-doctor').remove();
    } else {
        $('.drState').closest('.dropdownItemParent').show();
    }
}

async function setPageVariables(registeredPatients, registeredPharmacies, videoRatings, videoRatingCount) {
    return new Promise((resolve, reject) => {
        // Grab the container element

        $('div.not_a_patient_tile_content').contents().filter(function() {
            return this.nodeType == 3
        }).each(function(){
            this.textContent = this.textContent.replace('%patient_count%',registeredPatients);
        });
        
        $('div.star_head').contents().filter(function() {
            return this.nodeType == 3
        }).each(function(){
            this.textContent = this.textContent.replace('%video_rating%',videoRatings);
        });
        
        $('div.hero_banner_review_bar_info').contents().filter(function() {
            return this.nodeType == 3
        }).each(function(){
            this.textContent = this.textContent.replace('%rating_count%',videoRatingCount);
        });
        //container.html(container.html().replace('%pharmacy_count%', registeredPharmacies));

        resolve(true);
    });
}

async function statsScriptLoad() {
    /*
        Find any locations of counts and replace them
        it's heavy but we don't want to call the EP on every element
    
    var registeredPatients = 0;
    var registeredPharmacies = 0;
    var videoRatings = 0;
    var averageDoctorAndVideoRating = 0;
    var numberOfUsersThatRated = 0;
    
    // This is to lighten the stats refresh, we will only get the stats if we have to
    var statsExpire = localStorage.getItem('statsExpire');
    var timeUntilExpire = unixNow - parseInt(statsExpire);

    if (window.location.href.indexOf('/online-medical-certificates/') > -1 == true ) {
        videoRatings = await doGet(`${window.API_Path}statistics/doctorAndVideoRatings?outcomeType=MedicalCertificate`);
    } else if (window.location.href.indexOf('/online-specialist-referral-letters/') > -1 == true ) {
        videoRatings = await doGet(`${window.API_Path}statistics/doctorAndVideoRatings?outcomeType=Referral`);
    } else if (window.location.href.indexOf('/online-prescriptions/') > -1 == true ) {
        videoRatings = await doGet(`${window.API_Path}statistics/doctorAndVideoRatings?outcomeType=Prescription`);
    } else {
        videoRatings = await doGet(`${window.API_Path}statistics/doctorAndVideoRatings`);
    }
    averageDoctorAndVideoRating = videoRatings['averageDoctorAndVideoRating'];
    numberOfUsersThatRated = videoRatings['numberOfUsersThatRated'];

    if (timeUntilExpire >= 0 || !timeUntilExpire) {
        registeredPatients = await doGet(`${window.API_Path}statistics/registeredPatients`);
        registeredPharmacies = await doGet(`${window.API_Path}statistics/registeredPharmacies`);
        //videoRatings = await doGet(`${window.API_Path}statistics/doctorAndVideoRatings`);
        //averageDoctorAndVideoRating = videoRatings['averageDoctorAndVideoRating'];
        //numberOfUsersThatRated = videoRatings['numberOfUsersThatRated'];

        // Store the stats so we don't have to call again
        localStorage.setItem('registeredPatients', registeredPatients);
        localStorage.setItem('registeredPharmacies', registeredPharmacies);
        //localStorage.setItem('averageDoctorAndVideoRating', videoRatings['averageDoctorAndVideoRating']);
        //localStorage.setItem('numberOfUsersThatRated', videoRatings['numberOfUsersThatRated']);

        // Expire stats in 5 minutes
       localStorage.setItem('statsExpire', (unixNow + 300));
    } else {
        registeredPatients = localStorage.getItem('registeredPatients');
        registeredPharmacies = localStorage.getItem('registeredPharmacies');
        //averageDoctorAndVideoRating = localStorage.getItem('averageDoctorAndVideoRating');
        //numberOfUsersThatRated = localStorage.getItem('numberOfUsersThatRated');

    }
    
    await setPageVariables(registeredPatients, registeredPharmacies, averageDoctorAndVideoRating, numberOfUsersThatRated);

    */

    // Check Doctor online state every second
    checkDoctorOnlineState();
    setInterval(checkDoctorOnlineState, 30000);
}